import React from 'react';
import { Gift, Tag } from '@wix/wix-ui-icons-common/lazy';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { DomainSearchSuiteModule, ModalsModule } from '@wix/domains-search-suite';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { BaseVoucherBanner } from './VoucherBanner';
export const LoggedInMobileVoucherBanner = _ref => {
  let _ref$isOptimized = _ref.isOptimized,
    isOptimized = _ref$isOptimized === void 0 ? false : _ref$isOptimized;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    tSuite = _DomainSearchSuiteMod.t,
    Trans = _DomainSearchSuiteMod.Trans;
  const tldsSheet = ModalsModule.internals.domainsSharedModalsController.tldsSheet;
  const _DomainsApiClient$hoo = DomainsApiClient.hooks.useDomainsAccount({}),
    data = _DomainsApiClient$hoo.data,
    isLoading = _DomainsApiClient$hoo.isLoading;
  if (isLoading) {
    return null;
  }
  if (data != null && data.isPremiumSite && data != null && data.hasValidVouchers && data.voucherSupportedTlds.length) {
    return /*#__PURE__*/React.createElement(BaseVoucherBanner, {
      icon: /*#__PURE__*/React.createElement(Gift, null),
      content: /*#__PURE__*/React.createElement(Trans, {
        i18nKey: "domain_search_suite.mobile_banner.free_with_voucher",
        components: [/*#__PURE__*/React.createElement("b", null)]
      }),
      onInfoClick: () => tldsSheet.show({
        tlds: data.voucherSupportedTlds
      })
    });
  }
  if (data != null && data.isPremiumSite) {
    return /*#__PURE__*/React.createElement(BaseVoucherBanner, {
      icon: /*#__PURE__*/React.createElement(Tag, null),
      content: t('domain_search_gate.domain_gate.header.non_voucher')
    });
  }
  return /*#__PURE__*/React.createElement(BaseVoucherBanner, {
    icon: /*#__PURE__*/React.createElement(Gift, null),
    content: isOptimized ? tSuite('domains_search_suite.storefront.optimizations.voucher_banner') : tSuite('domain_search_suite.mobile.banner.promo.no_voucher.title')
  });
};
//# sourceMappingURL=LoggedInMobileVoucherBanner.js.map